module.exports = __webpack_public_path__ + "img/t.e2ad688d.svg";